// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ShowingCard = require("../common/Components/ShowingCard.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyPageShowingsList_showing_graphql = require("../../__generated__/PropertyPageShowingsList_showing_graphql.bs.js");
let PropertyPageShowingsList_showings_graphql = require("../../__generated__/PropertyPageShowingsList_showings_graphql.bs.js");

let convertFragment = PropertyPageShowingsList_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageShowingsList_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageShowingsList_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPageShowingsList_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageShowingsList_showing_graphql.node, convertFragment, fRef);
}

let ShowingFragment_showingTypeV5_decode = PropertyPageShowingsList_showing_graphql.Utils.showingTypeV5_decode;

let ShowingFragment_showingTypeV5_fromString = PropertyPageShowingsList_showing_graphql.Utils.showingTypeV5_fromString;

let ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__ShowingsList$Card(props) {
  let showing = RescriptRelay_Fragment.useFragment(PropertyPageShowingsList_showing_graphql.node, convertFragment, props.showing);
  let date = showing.startDateV2.toLocaleString("en-us", {
    weekday: "short",
    month: "short",
    day: "numeric"
  });
  let startTime = showing.startDateV2.toLocaleString("en-us", {
    hour: "numeric",
    minute: "numeric"
  });
  let endTime = showing.endDateV2.toLocaleString("en-us", {
    hour: "numeric",
    minute: "numeric"
  });
  let match = showing.type_;
  let badgeText;
  if (match === "AGENTS_ONLY" || match === "TAN_ONLY" || match === "BUYERS_WELCOME") {
    switch (match) {
      case "AGENTS_ONLY" :
        badgeText = "Agents only";
        break;
      case "BUYERS_WELCOME" :
        badgeText = "Buyers welcome";
        break;
      case "TAN_ONLY" :
        badgeText = "TAN only";
        break;
    }
  } else {
    badgeText = undefined;
  }
  return JsxRuntime.jsx(ShowingCard.make, {
    date: date,
    dateIcon: Primitive_option.some(showing.startDateV2.toPlainDate()),
    time: startTime + ` - ` + endTime,
    badgeText: badgeText,
    notes: showing.notes,
    showNotes: props.shouldShowPropertyDetails
  });
}

let Card = {
  ShowingFragment: ShowingFragment,
  make: PropertyPage__ShowingsList$Card
};

let convertFragment$1 = PropertyPageShowingsList_showings_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageShowingsList_showings_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageShowingsList_showings_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, PropertyPageShowingsList_showings_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageShowingsList_showings_graphql.node, convertFragment$1, fRef);
}

let ShowingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyPage__ShowingsList(props) {
  let shouldShowPropertyDetails = props.shouldShowPropertyDetails;
  let showings = RescriptRelay_Fragment.useFragment(PropertyPageShowingsList_showings_graphql.node, convertFragment$1, props.showings);
  let match = showings.length;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Showings",
        className: "text-2xl font-medium text-gray-800"
      }),
      JsxRuntime.jsx("div", {
        children: match !== 0 ? showings.map(showing => JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(PropertyPage__ShowingsList$Card, {
              showing: showing.fragmentRefs,
              shouldShowPropertyDetails: shouldShowPropertyDetails
            }),
            className: "max-w-md md:max-w-none"
          }, showing.id)) : "There are no scheduled showings.",
        className: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 items-stretch my-4"
      })
    ]
  });
}

let make = PropertyPage__ShowingsList;

exports.Card = Card;
exports.ShowingsFragment = ShowingsFragment;
exports.make = make;
/* ShowingCard Not a pure module */
